import {
  FETCH_WORK_INSIGHTS_HEATMAP,
  FETCH_WORK_INSIGHTS_SUMMARY,
  FETCH_WORK_INSIGHTS_LOCATIONS,
  FETCH_WORK_INSIGHTS_MOSTPOI,
  FETCH_WORK_INSIGHTS_SUBURBINFO,
  FETCH_WORK_INSIGHTS_BRANDAFFINITY,
  FETCH_WORK_INSIGHTS_LOCATION_TYPES,
  FETCH_WORK_INSIGHTS_HOME_LOCATIONS
} from '../constants';

export const fetchWorkInsightsHeatmap = () => ({
  type: FETCH_WORK_INSIGHTS_HEATMAP,
});

export const fetchWorkInsightsSummary = () => ({
  type: FETCH_WORK_INSIGHTS_SUMMARY,
});

export const fetchWorkInsightsLocations = () => ({
  type: FETCH_WORK_INSIGHTS_LOCATIONS,
});

export const fetchWorkInsightsMostPoi = () => ({
  type: FETCH_WORK_INSIGHTS_MOSTPOI,
});

export const fetchWorkInsightsSuburbInfo = () => ({
  type: FETCH_WORK_INSIGHTS_SUBURBINFO,
});

export const fetchWorkInsightsBrandAffinity = () => ({
  type: FETCH_WORK_INSIGHTS_BRANDAFFINITY,
});

export const fetchWorkInsightsLocationTypes = () => ({
  type: FETCH_WORK_INSIGHTS_LOCATION_TYPES,
});

export const fetchWorkInsightsHomeLocations = () => ({
  type: FETCH_WORK_INSIGHTS_HOME_LOCATIONS,
});

